import {Card} from "../../../basic/card.tsx";
import {Badge} from "../../../basic/badge.tsx";
import {AlertCircle, CheckCircle2, Package, Users} from "lucide-react";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";
import {VwpFeatureConfig} from "../../../../store/generated/api.ts";

interface StatsCardsProps {
    stats: {
        totalLicenses: number;
        activeLicenses: number;
        expiringLicenses: number;
        teamMembers: number;
        availableSeats: number;
    };
    config?: VwpFeatureConfig;
}

export function StatsCards({stats, config}: StatsCardsProps) {
    const {t} = useTranslationWithKeys();
    const hasUnlimitedSeats = config?.hasUnlimitedSeats;

    return (
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
            <Card className="p-6 shadow-sm border-border/50">
                <div className="flex items-center justify-between mb-2">
                    <p className="text-muted-foreground">{t('dashboard.totalLicenses')}</p>
                    <Package className="h-5 w-5 text-primary"/>
                </div>
                <div className="flex items-baseline gap-2">
                    <span className="text-3xl">{stats.totalLicenses}</span>
                    <Badge variant="secondary">{stats.activeLicenses} {t('dashboard.active')}</Badge>
                </div>
            </Card>

            <Card className="p-6 shadow-sm border-border/50">
                <div className="flex items-center justify-between mb-2">
                    <p className="text-muted-foreground">{t('dashboard.expiringSoon')}</p>
                    <AlertCircle className="h-5 w-5 text-orange-500"/>
                </div>
                <div className="flex items-baseline gap-2">
                    <span className="text-3xl">{stats.expiringLicenses}</span>
                    <span className="text-muted-foreground">{t('dashboard.licenses')}</span>
                </div>
            </Card>

            <Card className="p-6 shadow-sm border-border/50">
                <div className="flex items-center justify-between mb-2">
                    <p className="text-muted-foreground">{t('dashboard.teamMembers')}</p>
                    <Users className="h-5 w-5 text-primary"/>
                </div>
                <div className="flex items-baseline gap-2">
                    <span className="text-3xl">{stats.teamMembers}</span>
                    <span className="text-muted-foreground">{t('dashboard.members')}</span>
                </div>
            </Card>

            <Card className="p-6 shadow-sm border-border/50">
                <div className="flex items-center justify-between mb-2">
                    <p className="text-muted-foreground">{t('dashboard.availableSeats')}</p>
                    <CheckCircle2 className="h-5 w-5 text-primary"/>
                </div>
                <div className="flex items-baseline gap-2">
                    <span className="text-3xl">
                        {hasUnlimitedSeats ? t('dashboard.unlimited') : stats.availableSeats}
                    </span>
                    {!hasUnlimitedSeats && <span className="text-muted-foreground">{t('dashboard.seats')}</span>}
                </div>
            </Card>
        </div>
    );
}